import React, { Component } from 'react';
import { FormulasEditView } from '../Formula/FormulasEditView';
const FormulasTab = props => {
    return (
            <FormulasEditView plantID={props.plantID} />
    );
}
export default FormulasTab;